(function() {

  $(document).ready(function(){
    $("#confirm_password").blur(function() {
      if($("#customer_password").val() !== "") {

        var passwordValue = $("#customer_password").val();
        var confirmPasswordValue = $("#confirm_password").val();

        if(confirmPasswordValue != passwordValue) {  
          $(".password-error-message").show();
          $("#submitBtn").attr("disabled", true);
          $("#submitBtn").attr("data-password", "false");
        } else {          
          $(".password-error-message").hide();
          console.log($("#addressProvince").val());

          if($("#addressProvince").val() === null) {
            $("#submitBtn").attr("data-password", "true");
          } else {
            $("#submitBtn").removeAttr("disabled");
            $("#submitBtn").attr("data-password", "true");
          }
          
        }

      } else {
        console.log("empty")
      }
    })
  }) 

})();